import { PlusIcon } from '@heroicons/react/24/outline';
import { useAppDispatch } from 'app/hooks';
import { addExistingSystem } from 'features/structure/structure-slice';
import { nanoid } from 'nanoid';
import { ADD_ANOTHER_SYSTEM_LABEL } from 'utils/existing-equipment-steps';

export default function AddExistingSystemButton() {
  const dispatch = useAppDispatch();

  return (
    <button
      type='button'
      onClick={() => dispatch(addExistingSystem({ uniqueId: nanoid(5) }))}
      className='flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 bg-white px-4 py-4 text-base font-semibold text-gray-700 transition hover:border-blue-400 hover:text-blue-700'
    >
      <PlusIcon className='h-5 w-5 shrink-0' />
      {ADD_ANOTHER_SYSTEM_LABEL}
    </button>
  );
}
